(function ($) {
    $('div[data-ajax-url]').each(function () {
        var $this = $(this),
            dataURL = $this.attr('data-ajax-url'),
            callbackFn = $this.attr('data-ajax-callback');

        $this.load(dataURL, function () {
            $this.trigger(callbackFn);
        });
    });

    function initializeRelatedPackages() {
        var packageLength = $('#pdp-buy-grid-package').find('.product-thumb').length;

        if (packageLength > 1) {
            $('#pdp-related-packages').removeClass('hide');
            $('#related-product-anchor-link').removeClass('hide').scrollToID({
                offset: 40
            });
        }
    }

    function initializeSimilar() {
        //doing nothing for now
    }

    evo.$.body.on('initializeRelatedPackages', initializeRelatedPackages);
    evo.$.body.on('initializeSimilar', initializeSimilar);
})(jQuery);